import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 5v6a8 8 0 0 1 -8 8h-6","key":"svg-0"}]]

const IconRadiusBottomRight = createReactComponent('outline', 'radius-bottom-right', 'RadiusBottomRight', __iconNode);

export default IconRadiusBottomRight;